import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSimpleTable,_vm._b({},'v-simple-table',_vm.props.tableAttrs,false),[(_vm.props.caption)?_c('caption',[_vm._v(" "+_vm._s(_vm.props.caption)+" ")]):_vm._e(),_c('vt-table-head'),_c('vnodes',{attrs:{"vnodes":_vm.props.slots.beforeBody}}),_c('vt-table-body',{ref:"vt_table_body"}),_c('vnodes',{attrs:{"vnodes":_vm.props.slots.afterBody}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }